import React from 'react';

import { useWatch, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SourceGroupedCheckbox } from './components/SourceGroupedCheckbox';
import { CustomFilterPopover } from '../../components/CustomFilterPopover';
import { useFilterCount } from '../../hooks';

const DEFAULT_SOURCES_FIELD = 'sources';
const CREATED_SOURCES_FIELD = '__createdSources__';

interface SourceSelectPopoverProps {
  name?: string;
  onCountChange?: (key: string, count: string) => void;
}

export function SourceSelectPopover({
  name = DEFAULT_SOURCES_FIELD,
  onCountChange = undefined,
  ...props
}: SourceSelectPopoverProps): React.JSX.Element {
  const { t } = useTranslation();
  const { setValue } = useFormContext();

  const selectedSources = useWatch({ name }) ?? [];
  // служебное поле, подумать мб для группы "Добавленные источники" сделать хранение используя react-query
  const createdSources = useWatch({ name: CREATED_SOURCES_FIELD }) ?? [];

  const filterCount = Array.isArray(selectedSources) && selectedSources.length > 0 ? 1 : 0;

  useFilterCount(name, filterCount, onCountChange);

  return (
    // FIXME: CustomFilterPopover не ts. планируем от него избавиться
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="sourcesFilter"
      triggerValue={t('source')}
      {...props}
    >
      <SourceGroupedCheckbox
        customSourceNames={createdSources}
        onChangeCustomSourceNames={(v) => setValue(CREATED_SOURCES_FIELD, v)}
        onChangeSelectedSource={(v) => setValue(name, v)}
        selectedSources={selectedSources}
      />
    </CustomFilterPopover>
  );
}
